import React from "react";
import { Box, Typography, styled, Grid, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { imagesWEBP } from "../../constants/webpImages";
import MobileForm from "./MobileForm";
const CustomDialogBox = styled(Box)(({ theme }) => ({
  ".dialog-box": {
    padding: "4px",
  },
  ".grid-container": {
    display: "flex",

    justifyContent: "flex-start",
  },
  ".grid-item-style": {
    justifyContent: "flex-end",
    padding: "2px",
  },
  ".img-container": {
    width: "250px",
    padding: "2px",
  },
  ".vehicle-detail-container": {
    display: "flex",
    alignItems: "center",
  },
  ".VehicleName": {
    fontSize: "24px",
    fontWeight: "700",
  },

  [theme.breakpoints.down("sm")]: {
    ".VehicleName": {
      fontSize: "20px",
    },
    ".img-container": {
      width: "200px",
      padding: "2px",
    },
    ".vehicle-detail-container": {
      maxWidth: "120px",
    },
  },
}));
const NoDescriptionPopUp = ({ open, vehicleData, onClose }) => {
  return (
    <Dialog className="dialog-box" onClose={onClose} open={open}>
      <DialogContent>
        <CustomDialogBox>
          <Grid container className="grid-container">
            <Grid item xs={6}>
              <Stack sx={{ width: "200px", justifyContent: "flex-start" }}>
                <LazyLoadImage src={imagesWEBP?.launchOfferImg} alt={vehicleData?.vehicle_name}/>
              </Stack>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            className="grid-container"
            style={{ marginTop: "4px" }}
          >
            <Grid item xs={6} justifyContent={"flex-start"}>
              <Box className="vehicle-detail-container">
                <Box>
                  <Typography className="VehicleName">
                    {vehicleData?.brand}
                  </Typography>
                  <Typography className="VehicleName">
                    {vehicleData?.vehicle_name}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={6}
              className="grid-item-style"
              justifyContent={"flex-end"}
            >
              <Stack className="img-container">
                <LazyLoadImage src={vehicleData?.storeImage} alt={vehicleData?.vehicle_name}/>
              </Stack>
            </Grid>
          </Grid>
          <MobileForm onClose={onClose} />
        </CustomDialogBox>
      </DialogContent>
    </Dialog>
  );
};

export default NoDescriptionPopUp;
